import { useRadarForegroundTracking as useRadarForegroundTrackingBase } from '@sg/radar-fe';

import { useFeatureFlag } from '@order/LaunchDarkly';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Order-app wrapper for Radar foreground tracking.
 *
 * Reads the feature flag, then delegates to the platform hook in `@sg/radar-fe`.
 */
export const useRadarForegroundTracking = (params: Params) => {
  const { isCustomerLoggedIn, isReady } = params;

  const isEnabled = useFeatureFlag('CELS-4898-radar-geofence-enabled');
  const isAllUserTrackingEnabled = useFeatureFlag('CELS-5507-order-radar-track-all-users-enabled');

  // ─── Derived ─────────────────────────────────────────────────────────

  const shouldTrackUser = isCustomerLoggedIn || isAllUserTrackingEnabled;
  const shouldEnableTracking = isEnabled && isReady && shouldTrackUser;

  // ─── Effects ─────────────────────────────────────────────────────────

  useRadarForegroundTrackingBase({ isEnabled: shouldEnableTracking });
};

// ─── Types ──────────────────────────────────────────────────────────────────

type Params = {
  isCustomerLoggedIn: boolean;
  isReady: boolean;
};
